import fetch from '@giro/shared-utils/fetch.util';

type BodyType = {
  phone_number: string;
};

export default async function postApiAccountsResendConfirmationPhoneService(
  body: BodyType
) {
  return fetch('accounts/resend-confirmation-phone', {
    method: 'POST',
    ms: 'USERS',
    auth: true,
    body: JSON.stringify(body),
  });
}
